const USER_CAPABILITIES = {
  CAPABILITY_STUDENT_COURSE_PLAN_MODIFICATION:
    'student_course_plan_modification',
  CAPABILITY_STUDENT_CONTACT: 'student_contact',
  CAPABILITY_STUDENT_GROUP_MANAGEMENT: 'student_group_management',
  CAPABILITY_TRANSCRIPT_MANAGEMENT: 'transcript_management',
  CAPABILITY_COURSE_CATALOG: 'course_catalog',
  CAPABILITY_SCHOOL_ADMIN_MANAGEMENT: 'school_admin_management',
  CAPABILITY_ACCOUNTABILITY_INDICATOR_CONFIGURATION:
    'accountability_indicator_configuration',
  CAPABILITY_INDUSTRY_PARTNERS: 'industry_partners',
  CAPABILITY_INDUSTRY_PARTNERS_READ_ONLY: 'industry_partners_read_only',
  CAPABILITY_SCHOLARSHIP_MANAGEMENT: 'scholarship_management',
  CAPABILITY_OPPORTUNITY_MANAGEMENT: 'opportunity_management',
  CAPABILITY_DATA_UPLOAD: 'data_upload',
  CAPABILITY_DISTRICT_SETTINGS: 'district_settings',
  CAPABILITY_COLLEGE_PARTNER_MANAGEMENT: 'college_partner_management',
  CAPABILITY_ALUMNI_MANAGEMENT: 'alumni_management',
  CAPABILITY_INTERNAL_EVENT_MANAGEMENT: 'internal_event_management',
  CAPABILITY_TRANSCRIPT_FULFILLMENT: 'transcript_fulfillment',
  CAPABILITY_COLLEGE_APPLICATION_MANAGEMENT: 'college_application_management',
  CAPABILITY_COLLEGE_COST_ACCESS: 'college_cost_access',
  CAPABILITY_EXPERIENCE_TRACKING_SETUP: 'experience_tracking_setup',
  CAPABILITY_EXPERIENCE_TRACKING_APPROVAL: 'experience_tracking_approval',
  CAPABILITY_ELEMENTARY_CHECKINS_SCHEDULE: 'elementary_checkins_schedule',
  CAPABILITY_SEL_CHECKINS_SCHEDULE: 'sel_checkins_schedule',
  CAPABILITY_PERSONALIZED_PLANS_CONFIGURATION:
    'personalized_plan_configuration',
  CAPABILITY_PROGRAM_MANAGEMENT: 'program_management',
  CAPABILITY_STUDENT_MEETINGS_AND_NOTES: 'student_note_and_meeting_log_access',
  KRI_CONFIGURATION: 'kri_configuration',
  HE_SCHOOL_COMMENT_MANAGEMENT: 'he_school_comment_management',
};

export default USER_CAPABILITIES;
